module.exports = __webpack_public_path__ + "static/media/Apartment-8@2x.8f83ae93.png";